import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../inputs/button';

const EntityHeader = props => {
  const {
    entityNamePlural,
    entityNameSingular,
    handleFormPopup,
    handleImportFormPopup,
    alternativeTitle,
    handleRefresh,    
    handleImportExtraInfoPopup
  } = props;
  return (
    <div className="entity_header">
      <div className='entity_title'>
        {alternativeTitle ? alternativeTitle : (
           <FormattedMessage 
             id="common.entity.entityTable.title" 
             values={{entityNamePlural: entityNamePlural}}
           />
        )}
      </div>
      <div className="entity_header_buttons_wrapper">
        {handleRefresh && (
          <i 
            className={"fas fa-sync entity_header_refresh_button"}
            onClick={handleRefresh}
            id="entity_header_refresh_button"
          />
        )}
        {handleImportFormPopup && (
          <Button
            onClick={handleImportFormPopup}
            labelLocale={<FormattedMessage 
               id="common.entity.importEntities"
             />}
             id={"entity_header_import_button"}
          />
        )}        
        {(handleImportFormPopup && handleImportExtraInfoPopup) && (
          <label className="entity_header_import_info_button">
            <i className="fas fa-info-circle" onClick={handleImportExtraInfoPopup}></i>
          </label>
        )}
        {handleFormPopup && (
          <Button
            onClick={handleFormPopup}
            labelLocale={<FormattedMessage 
               id="common.entity.createEntity" 
               values={{entityNameSingular: entityNameSingular}}
             />}
            id={"entity_header_form_popup_button"}
          />
        )}
      </div>
    </div>
  );
};

export default EntityHeader;



// WEBPACK FOOTER //
// ./source/client/components/common/entity/entityHeader.jsx